<template>
  <v-dialog v-model="open" max-width="480">
    <v-card>
      <v-card-title class="headline">{{ $t("templateUse.chooseFolder") }}</v-card-title>
      <v-card-text>
        <v-select
          v-model="selected"
          :items="folders"
          item-text="name"
          item-value="_id"
          :label="$t('templateUse.folder')"
          :loading="loading"
          return-object
          outlined
          dense
          hide-details
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="open = false">{{ $t("general.cancel") }}</v-btn>
        <v-btn color="primary" :disabled="!selected" @click="confirm">
          {{ $t("general.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "templateTargetFolderDialog",
  props: {
    loadAction: { type: String, required: true },
  },
  data: () => ({
    open: false,
    loading: false,
    folders: [],
    selected: null,
    resolve: null,
  }),
  methods: {
    async pick() {
      this.selected = null;
      this.open = true;
      this.loading = true;
      try {
        const res = await this.$store.dispatch(this.loadAction);
        this.folders = ((res && res.data) || res || []).map((f) => ({
          ...f,
          _id: f._id || f.id,
        }));
      } finally {
        this.loading = false;
      }
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    confirm() {
      this.open = false;
      if (this.resolve) this.resolve(this.selected);
      this.resolve = null;
    },
  },
  watch: {
    open(value) {
      if (!value && this.resolve) {
        this.resolve(null);
        this.resolve = null;
      }
    },
  },
};
</script>
